jQuery('.slide-testimonial').slick({
    dots: true,
    arrows: true,
    infinite: true,
    slidesToShow: 1,
    autoplay: false,
    speed: 1000,
    autoplaySpeed: 3000,
    slidesToScroll: 1,
});   
$(".faq-item").click(function() {
// Toggle the answer when clicking on a question
$(this).find(".faq-answer").slideToggle(300);

// Close other answers
$(".faq-item").not(this).find(".faq-answer").slideUp(300);
});  

jQuery('.faq-list .accordion-item').click(function(){
  if( jQuery(this).hasClass('active-drop') ) {
      jQuery('.faq-list .accordion-item').removeClass('active-drop');
  } else {
      jQuery('.faq-list .accordion-item').removeClass('active-drop');
      jQuery(this).addClass('active-drop');
  }
});



$(".tab").on("click", function () {
  var target = $(this).data("tab");

  $(".tab").removeClass("active");
  $(".tab-content").removeClass("active");

  $(this).addClass("active");
  $("#" + target).addClass("active");
});
